module.exports = __webpack_public_path__ + "static/media/TN_Women_Sneaker_2.0_OptionAll.615e7e19.svg";